import React from 'react';

import { NetworkCurrencySymbol } from 'components/CurrencySymbols';
import { IS_CHRISTMAS_TIME, IS_EASTER_TIME } from 'const';
import DogeWinBear_regular from 'assets/art/DogeWinSwagRed.webp';
import DogeWinBull_regular from 'assets/art/DogeWinSwagGreen.webp';
import DogeWinBear_Christmas from 'assets/art/DogeWinSwagRed_Christmas.webp';
import DogeWinBull_Christmas from 'assets/art/DogeWinSwagGreen_Christmas.webp';
import DogeWinBear_Easter from 'assets/art/DogeWinSwagRed_Easter.webp';
import DogeWinBull_Easter from 'assets/art/DogeWinSwagGreen_Easter.webp';
import './styles.scss';

class CardPreviousBackside extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bearVictory: false,
      roundNumberTooLong: false,
    }
    if (IS_CHRISTMAS_TIME) {
      this.bearBackside = DogeWinBear_Christmas;
      this.bullBackside = DogeWinBull_Christmas;
    } else if (IS_EASTER_TIME) {
      this.bearBackside = DogeWinBear_Easter;
      this.bullBackside = DogeWinBull_Easter;
    } else {
      this.bearBackside = DogeWinBear_regular;
      this.bullBackside = DogeWinBull_regular;
    }
  }

  get victoryImage() {
    if (this.state.bearVictory)
      return this.bearBackside;
    else
      return this.bullBackside;
  }

  componentDidMount() {
    if (this.props.bearVictory === null || this.props.bearVictory === undefined)
      throw new SyntaxError('missing required props: bearVictory');
    const roundNumberTooLong = (this.props.roundNumber.toString().length > 5);
    this.setState({
      bearVictory: this.props.bearVictory,
      useSmallFontForRoundNumber: roundNumberTooLong,
    });
  }

  componentDidUpdate() {
    if (this.props.bearVictory !== this.state.bearVictory)
      this.setState({ bearVictory: this.props.bearVictory });
  }


  render() {
    return (<div className='CardPreviousOld Backside'>
      <div className='VictoryImageContainer' style={{ backgroundImage: `url(${this.victoryImage})` }}>
        <div className='Top' >
          <p>Congratulations!</p>
        </div>
        <div className='DogeFace' ></div>
        <div className='Goblet' >
          <div className='Reward' >
            <p>{this.props.amountWon}</p>
            <NetworkCurrencySymbol />
          </div>
          <p className={'RoundNumber ' + (this.state.useSmallFontForRoundNumber ? 'L' : '')}>
            {this.props.roundNumber}
          </p>
        </div>
        <div className='Bottom' ></div>
      </div>
    </div>);
  }
}

export default CardPreviousBackside;